import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/components/admin/use-theme";

/**
 * ThemeToggle — botón circular siempre visible que alterna light/dark.
 *
 * Estilo P3: 36px círculo, sombra estándar, icono sol/luna, rota 20°
 * al hover. La persistencia ya está manejada por `useTheme` (localStorage
 * key "vite-ui-theme").
 */
export function ThemeToggle({
  className,
}: {
  className?: string;
}) {
  const { theme, setTheme } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className={"musco-theme-btn " + (className ?? "")}
      title={isDark ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
      aria-label={isDark ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
    >
      {isDark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}
